import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./projects_dropdown/event_hub.js